import React from "react";
import { RiLockPasswordLine } from "react-icons/ri";

const ForgotPassword = ({
  forgotLoading,
  setForgotPasswordModal,
  handleForgotPassword,
  setEmail,email
}) => {
  return (
    <div
      className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50"
      onClick={() => setForgotPasswordModal(false)}
    >
      <div
        className="bg-white p-8 rounded-md shadow-md w-full max-w-lg mx-3 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-bold text-[#405189] text-center mb-1">
          Forgot Your Password?
        </h2>
        <div className="flex justify-center my-6">
          <RiLockPasswordLine size={80} className="text-[#F48224]" />
        </div>

        <p className="text-center text-gray-500">
          Enter your email address to receive a password reset link.
        </p>
        <form onSubmit={handleForgotPassword}>
          <div className="mb-4 mt-6">
            <label className="block text-sm font-medium mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Your Email Address"
              autoComplete="off"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-[#F48224] mt-3 text-white py-2 rounded-md hover:bg-[#e0731a] transition flex justify-center"
          >
            {forgotLoading ? <div className="loader"></div> : "Send Reset Link"}
          </button>
        </form>
        <div
          className="flex items-center justify-center mt-3 cursor-pointer"
          onClick={() => setForgotPasswordModal(false)}
        >
          <p className="text-blue-800 text-md hover:underline">Back to Login</p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
